import { render } from "./ArtigosView.vue?vue&type=template&id=6f3de19e"
import script from "./ArtigosView.vue?vue&type=script&lang=js"
export * from "./ArtigosView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__